export const clearLocalStorage = (preservingKeys = [] as string[]) => {
  const taskFormDataKeys = Object.keys(localStorage).filter(key =>
    /^task-\d+-form-data$/.test(key),
  );
  const associationKeys = Object.keys(localStorage).filter(key => /^association-.+$/.test(key));
  const filterKeys = Object.keys(localStorage).filter(key => /^filters-.+$/.test(key));

  const preservingKeysDefault: string[] = [
    ...preservingKeys,
    ...taskFormDataKeys,
    ...associationKeys,
    ...filterKeys,
    'sidebar',
  ];

  for (const key of Object.keys(localStorage)) {
    if (!preservingKeys.includes(key) && !preservingKeysDefault.includes(key)) {
      localStorage.removeItem(key);
    }
  }
};
